import { Box, Typography, Button, Drawer, Alert } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import EditIcon from '@mui/icons-material/Edit';
import { useGlobalContext } from '../context/GlobalProvider';
import ProfileEditModal from '../components/modals/ProfileEditModal';

import Amateur from '../components/Amateur';
import Infantiles from '../components/Infantiles';
import { useState, useEffect, useCallback, useRef } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import UserData from '../components/data/UserData';
import GiraInfIns from '../components/data/GiraInfIns';
import GiraInfData from '../components/data/GiraInfData';
import GiraAmaData from '../components/data/GiraAmaData';
import GiraAmaIns from '../components/data/GiraAmaIns';
import { getAmateur } from '../components/data/AmateurData';
import ClubesData from '../components/data/ClubesData';
import HijosData from '../components/data/HijosData';

const Home = () => {
  const { user } = useGlobalContext();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [userData, setUserData] = useState(null);
  const [isAmateur, setIsAmateur] = useState(false);
  // Keep-alive: mount each panel once visited, hide with CSS instead of unmounting
  const [visitedInfantiles, setVisitedInfantiles] = useState(true);
  const [visitedAmateur, setVisitedAmateur] = useState(false);

  const handleCategoryToggle = () => {
    setIsAmateur((prev) => {
      const next = !prev;
      if (next) setVisitedAmateur(true);
      else setVisitedInfantiles(true);
      return next;
    });
  };
  const [hasProfile, setHasProfile] = useState(false);
  const [amateurData, setAmateurData] = useState(null);
  const [clubes, setClubes] = useState([]);
  const [giras, setGiras] = useState([]);
  const [registeredChildren, setRegisteredChildren] = useState([]);
  
  // Infantiles registration states
  const [userPadcodigo, setUserPadcodigo] = useState(null);
  const [currentGira, setCurrentGira] = useState(null);
  const [infantilesRegistrations, setInfantilesRegistrations] = useState([]);
  const [loadingRegistrations, setLoadingRegistrations] = useState(false);
  const [bonificaciones, setBonificaciones] = useState({});

  // Amateur registration states (Acciones Requeridas)
  const [currentGiraAmateur, setCurrentGiraAmateur] = useState(null);
  const [amateurRegistrations, setAmateurRegistrations] = useState([]);
  const [loadingAmateurRegistrations, setLoadingAmateurRegistrations] = useState(false);
  
  // Refs to prevent duplicate calls
  const giraFetchedRef = useRef(false);
  const registrationsFetchedRef = useRef(false);
  const giraAmateurFetchedRef = useRef(false);
  const amateurRegistrationsFetchedRef = useRef(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Changed from 'sm' to 'md'
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg')); // Add tablet breakpoint
  const [drawerOpen, setDrawerOpen] = useState(false);

  const fetchUserData = useCallback(async () => {
    if (user?.email) {
      try {
        const data = await UserData.fetch(user.email);
        setUserData(data);
        
        // Check if user has a profile (has padcodigo or Padre data)
        const hasProfileData = data.padcodigo || (data.Padre && data.Padre.length > 0);
        setHasProfile(hasProfileData);
        
        // Extract padcodigo from user data for infantiles registrations
        if (data.padcodigo) {
          //console.log('Setting padcodigo:', data.padcodigo);
          setUserPadcodigo(data.padcodigo);
        } else if (data.Padre && data.Padre.length > 0) {
          console.log('Setting padcodigo from Padre array:', data.Padre[0].padcodigo);
          setUserPadcodigo(data.Padre[0].padcodigo);
        } else {
          console.log('No padcodigo found in user data');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        setHasProfile(false);
      }
    }
  }, [user?.email]);

  // Fetch amateur data
  const fetchAmateurData = useCallback(async () => {
    if (user?.email) {
      try {
        const data = await getAmateur(user.email);
        setAmateurData(data);
      } catch (error) {
        console.error('Error fetching amateur data:', error);
        setAmateurData(null);
      }
    }
  }, [user?.email]);

  // Fetch clubes data
  const fetchClubes = useCallback(async () => {
    try {
      const clubesData = await ClubesData.fetch();
      setClubes(clubesData);
    } catch (error) {
      console.error('Error fetching clubes:', error);
      setClubes([]);
    }
  }, []);

  // Fetch giras infantiles data
  const fetchGiras = useCallback(async () => {
    try {
      const girasData = await GiraInfData.fetch();
      setGiras(girasData);
    } catch (error) {
      console.error('Error fetching giras data:', error);
      setGiras([]);
    }
  }, []);

  // Fetch user's children data
  const fetchChildren = useCallback(async () => {
    if (user?.email) {
      try {
        const childrenData = await HijosData.fetch(user.email);
        setRegisteredChildren(childrenData);
      } catch (error) {
        console.error('Error fetching children data:', error);
        setRegisteredChildren([]);
      }
    }
  }, [user?.email]);

  // Fetch current gira data
  const fetchCurrentGira = useCallback(async () => {
    if (giraFetchedRef.current) return; // Prevent duplicate calls
    
    try {
      const girasData = await GiraInfData.fetch();
      //console.log('Giras data:', girasData);
      if (Array.isArray(girasData) && girasData.length > 0) {
        //console.log('Setting current gira:', girasData[0].gira);
        setCurrentGira(girasData[0]); // Get the first (current) gira
        giraFetchedRef.current = true; // Mark as fetched
      } else {
        console.log('No giras data found or empty array');
      }
    } catch (error) {
      console.error('Error fetching current gira:', error);
    }
  }, []);

    // Fetch infantiles registrations
  const fetchInfantilesRegistrations = useCallback(async () => {
    if (registrationsFetchedRef.current) return; // Prevent duplicate calls
    
    console.log('Fetching registrations with - userPadcodigo:', userPadcodigo, 'gira:', currentGira.gira);
    setLoadingRegistrations(true);
    try {
      const registrations = await GiraInfIns.fetch(userPadcodigo, currentGira.gira);
      setInfantilesRegistrations(registrations);
      registrationsFetchedRef.current = true; // Mark as fetched
      
      // Fetch bonificaciones for each registration
      if (registrations && registrations.length > 0) {
        const bonificacionesData = {};
        for (const reg of registrations) {
          if (reg.inscodigo) {
            try {
              const bonificacion = await GiraInfIns.getBonificacion(reg.inscodigo);
              bonificacionesData[reg.inscodigo] = bonificacion;
            } catch (error) {
              console.error(`Error fetching bonificacion for inscodigo ${reg.inscodigo}:`, error);
              bonificacionesData[reg.inscodigo] = [];
            }
          }
        }
        setBonificaciones(bonificacionesData);
      }
    } catch (error) {
      console.error('Error fetching infantiles registrations:', error);
      setInfantilesRegistrations([]);
    } finally {
      setLoadingRegistrations(false);
    }
  }, [userPadcodigo, currentGira]);

  // Fetch current gira amateur (for Acciones Requeridas)
  const fetchCurrentGiraAmateur = useCallback(async () => {
    if (giraAmateurFetchedRef.current) return;
    try {
      const girasData = await GiraAmaData.fetch();
      if (Array.isArray(girasData) && girasData.length > 0) {
        setCurrentGiraAmateur(girasData[0]);
        giraAmateurFetchedRef.current = true;
      }
    } catch (error) {
      console.error('Error fetching current amateur gira:', error);
    }
  }, []);

  // Fetch amateur registrations (for Acciones Requeridas)
  const fetchAmateurRegistrations = useCallback(async () => {
    if (amateurRegistrationsFetchedRef.current) return;
    const amateurCodigo = amateurData?.[0]?.AmateurCodigo;
    const giraCodigo = currentGiraAmateur?.gira;
    if (!amateurCodigo || !giraCodigo) return;
    setLoadingAmateurRegistrations(true);
    try {
      const registrations = await GiraAmaIns.fetch(amateurCodigo, giraCodigo);
      setAmateurRegistrations(Array.isArray(registrations) ? registrations : []);
      amateurRegistrationsFetchedRef.current = true;
    } catch (error) {
      console.error('Error fetching amateur registrations:', error);
      setAmateurRegistrations([]);
    } finally {
      setLoadingAmateurRegistrations(false);
    }
  }, [amateurData, currentGiraAmateur]);

  useEffect(() => {
    fetchUserData();
    fetchAmateurData();
    fetchCurrentGira();
    fetchClubes();
    fetchGiras();
    fetchChildren();
  }, [fetchUserData, fetchAmateurData, fetchCurrentGira, fetchClubes, fetchGiras, fetchChildren]);

  useEffect(() => {
    if (userPadcodigo && currentGira) {
      fetchInfantilesRegistrations();
    }
  }, [userPadcodigo, currentGira, fetchInfantilesRegistrations]);

  useEffect(() => {
    if (isAmateur) {
      fetchCurrentGiraAmateur();
    }
  }, [isAmateur, fetchCurrentGiraAmateur]);

  useEffect(() => {
    if (isAmateur && amateurData?.length > 0 && currentGiraAmateur) {
      fetchAmateurRegistrations();
    }
  }, [isAmateur, amateurData, currentGiraAmateur, fetchAmateurRegistrations]);



  // Refactor left column content for reuse
  const leftColumnContent = (
    <>
      <Box sx={{
        bgcolor: 'background.paper',
        borderRadius: 3,
        boxShadow: 1,
        p: 3,
        height: { xs: 'auto', sm: 'calc(50% - 12px)' },
        overflow: 'auto',
        mb: 2
      }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Perfil de usuario
        </Typography>
        {/* Alerta deshabilitada de momento. Para reactivar: cambiar showProfileUpdateAlert a true */}
        {false && (
          <Box sx={{
            mt: 2,
            p: 2,
            border: '2px solid #ef4444',
            borderRadius: 3,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <WarningAmberIcon sx={{ color: '#ef4444' }} />
            <Typography sx={{ color: '#ef4444' }}>
              Manten tus datos personales actualizados
            </Typography>
          </Box>
        )}
        {/* User Profile Box */}
        <Box sx={{
          mt: 3,
          p: 3,
          border: '1px solid #e5e7eb',
          borderRadius: 3,
          display: 'flex',
          gap: 3,
          alignItems: 'center'
        }}>
                     {/* Image Box - Responsive visibility based on available space */}
           <Box sx={{
             width: { xs: 80, sm: 100 },
             height: { xs: 80, sm: 100 },
             borderRadius: 3,
             bgcolor: '#f3f4f6',
             display: { 
               xs: 'none', // Always hidden on mobile
               sm: 'none', // Hidden on small screens too
               md: 'flex'  // Only show on medium+ screens where there's enough space
             },
             alignItems: 'center',
             justifyContent: 'center',
             overflow: 'hidden',
             flexShrink: 0
           }}>
             <img 
               src={user?.avatar || "https://via.placeholder.com/100"} 
               alt="Profile" 
               style={{ width: '100%', height: '100%', objectFit: 'cover' }}
             />
           </Box>

           {/* User Data */}
           <Box sx={{ 
             flex: 1,
             display: 'flex',
             flexDirection: 'column',
             justifyContent: 'center',
             textAlign: { xs: 'center', sm: 'center', md: 'left' }, // Center text when image is hidden
             minWidth: 0
           }}>
             <Typography 
               variant="h6" 
               sx={{ 
                 fontWeight: 'bold', 
                 mb: { xs: 0.5, sm: 1 },
                 fontSize: { 
                   xs: '1.1rem',    // Slightly larger on mobile since we have more space
                   sm: '1.2rem',     // Larger on small screens
                   md: '1.25rem'     // Full size on desktop
                 },
                 lineHeight: 1.1,    // Even tighter line height
                 wordBreak: 'normal', // Let text wrap naturally instead of breaking words
                 hyphens: 'auto'      // Add hyphens for better text flow
               }}
             >
               {userData ? `${userData.nombre} ${userData.apellidoPaterno} ${userData.apellidoMaterno}` : 'Usuario'}
             </Typography>
             <Typography 
               color="text.secondary" 
               sx={{ 
                 mb: 0.5,
                 fontSize: { xs: '0.9rem', sm: '1rem' },
                 lineHeight: 1.1,    // Tighter line height
                 wordBreak: 'normal', // Natural word breaking
                 hyphens: 'auto'      // Better hyphenation
               }}
             >
               {user?.email || 'No email provided'}
             </Typography>
           </Box>
        </Box>
        <Button 
          variant="outlined" 
          startIcon={<EditIcon />}
          fullWidth
          sx={{ 
            borderRadius: 2,
            textTransform: 'none',
            mt: 2
          }}
          onClick={() => setIsEditModalOpen(true)}
        >
          Editar Perfil
        </Button>
      </Box>
      <Box sx={{
        bgcolor: 'background.paper',
        borderRadius: 3,
        boxShadow: 1,
        p: 3,
        height: { xs: 'auto', sm: 'calc(50% - 12px)' },
        overflow: 'auto'
      }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Acciones Requeridas
        </Typography>
        {isAmateur ? (
          <Box sx={{ mt: 2 }}>
            {loadingAmateurRegistrations ? (
              <Typography color="text.secondary">
                Cargando registros...
              </Typography>
            ) : !currentGiraAmateur ? (
              <Typography color="text.secondary">
                No hay giras amateur vigentes
              </Typography>
            ) : amateurRegistrations.length === 0 ? (
              <Box>
                <Typography variant="body2" color="warning.main" sx={{ mb: 1 }}>
                  ⚠ No tienes registros activos
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Inscríbete en la sección Gira Amateur
                </Typography>
              </Box>
            ) : (() => {
              const pendingPayments = amateurRegistrations.filter(reg => reg.AmaInsMarcaPago !== 1);
              const registrationsWithAdeudo = pendingPayments.map(reg => {
                const baseImporte = Number(reg.AmaInsImporte) || 0;
                const refCount = Number(reg.ReferenciasUsadas) || 0;
                const descuento = refCount * 2000;
                const adeudo = Math.max(0, baseImporte - descuento);
                return {
                  ...reg,
                  adeudo
                };
              });
              const hasAdeudo = registrationsWithAdeudo.some(reg => reg.adeudo > 0);

              if (hasAdeudo) {
                const adeudoRegistrations = registrationsWithAdeudo.filter(reg => reg.adeudo > 0);
                return (
                  <Box>
                    <Typography variant="body2" color="red" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                      ⚠ Tiene Saldo pendiente
                    </Typography>
                    {adeudoRegistrations.map((reg, index) => (
                      <Typography key={index} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                        • {reg.AmaInsNombre || '—'} - <span style={{ color: 'red', fontWeight: 'bold' }}>${reg.adeudo.toFixed(2)}</span>
                      </Typography>
                    ))}
                  </Box>
                );
              }
              if (pendingPayments.length > 0) {
                return (
                  <Box>
                    <Typography variant="body2" color="red" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                      ⚠ Tiene Saldo pendiente
                    </Typography>
                    {pendingPayments.map((reg, index) => (
                      <Typography key={index} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                        • {reg.AmaInsNombre || '—'}
                      </Typography>
                    ))}
                  </Box>
                );
              }
              return (
                <Box>
                  <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>
                    ✓ Tienes {amateurRegistrations.length} registro(s) activo(s)
                  </Typography>
                  {amateurRegistrations.map((reg, index) => (
                    <Typography key={index} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      • {reg.AmaInsNombre || '—'} - <span style={{ color: 'green', fontWeight: 'bold' }}>PAGADO</span>
                    </Typography>
                  ))}
                </Box>
              );
            })()}
          </Box>
        ) : (
          <Box sx={{ mt: 2 }}>
            {loadingRegistrations ? (
              <Typography color="text.secondary">
                Cargando registros...
              </Typography>
            ) : currentGira ? (
              <Box>
                {(() => {
                  if (infantilesRegistrations.length === 0) {
                    return (
                      <Box>
                        <Typography variant="body2" color="warning.main" sx={{ mb: 1 }}>
                          ⚠ No tienes registros activos
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Inscribe a tus hijos en la sección de Infantiles
                        </Typography>
                      </Box>
                    );
                  }

                  // Check for pending payments
                  const pendingPayments = Array.isArray(infantilesRegistrations) 
                    ? infantilesRegistrations.filter(reg => reg.insmarcapago !== 1)
                    : [];
                  
                  // Calculate adeudo only for unpaid registrations
                  const registrationsWithAdeudo = Array.isArray(infantilesRegistrations)
                    ? infantilesRegistrations
                        .filter(reg => reg.insmarcapago !== 1) // Only unpaid registrations
                        .map(reg => {
                          const regBonificaciones = Array.isArray(bonificaciones[reg.inscodigo]) ? bonificaciones[reg.inscodigo] : [];
                          const totalBonificacion = regBonificaciones.reduce((sum, bon) => sum + (bon.Bonimporte || 0), 0);
                          
                          const adeudo = (reg.insimpcnij || 0) + (reg.insimporte || 0) + (reg.insimportewagr || 0) - totalBonificacion;
                          
                          console.log('Adeudo calculation for', reg.insnombreh, ':', {
                            insimpcnij: reg.insimpcnij,
                            insimporte: reg.insimporte,
                            insimportewagr: reg.insimportewagr,
                            totalBonificacion,
                            adeudo: Math.max(0, adeudo)
                          });
                          
                          return {
                            ...reg,
                            adeudo: Math.max(0, adeudo) // Ensure adeudo is not negative
                          };
                        })
                    : [];
                  
                  // Check if there are any adeudos
                  const hasAdeudo = registrationsWithAdeudo.some(reg => reg.adeudo > 0);
                  console.log('Has adeudo:', hasAdeudo, 'Pending payments:', pendingPayments.length);
                  
                  if (hasAdeudo) {
                    const adeudoRegistrations = registrationsWithAdeudo.filter(reg => reg.adeudo > 0);
                    console.log('Showing adeudo registrations:', adeudoRegistrations);
                    return (
                      <Box>
                        <Typography variant="body2" color="red" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                          ⚠ Tiene saldo pendiente
                        </Typography>
                        {adeudoRegistrations.map((reg, index) => (
                          <Typography key={index} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                            • {reg.insnombreh} - <span style={{ color: 'red', fontWeight: 'bold' }}>${reg.adeudo.toFixed(2)}</span>
                          </Typography>
                        ))}
                      </Box>
                    );
                  } else if (pendingPayments.length > 0) {
                    return (
                      <Box>
                        <Typography variant="body2" color="red" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                          ⚠ Tiene saldo pendiente
                        </Typography>
                        {pendingPayments.map((reg, index) => (
                          <Typography key={index} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                            • {reg.insnombreh}
                          </Typography>
                        ))}
                      </Box>
                    );
                  } else {
                    return (
                      <Box>
                        <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>
                          ✓ Tienes {Array.isArray(infantilesRegistrations) ? infantilesRegistrations.length : 0} registro(s) activo(s)
                        </Typography>
                        {Array.isArray(infantilesRegistrations) && infantilesRegistrations.map((reg, index) => (
                          <Typography key={index} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                            • {reg.insnombreh} - <span style={{ color: 'green', fontWeight: 'bold' }}>PAGADO</span>
                          </Typography>
                        ))}
                      </Box>
                    );
                  }
                })()}
              </Box>
            ) : (
              <Typography color="text.secondary">
                No hay giras vigentes
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </>
  );

  return (
    <Box sx={{
      width: '100%',
      height: '100vh',
      position: 'relative',
      p: { xs: 2, sm: 3 }, // Responsive padding
      boxSizing: 'border-box'
    }}>
      {isMobile ? (
        <>
          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            ModalProps={{ keepMounted: true }}
          >
            <Box sx={{ 
              width: { xs: 280, sm: 300 }, // Responsive drawer width
              p: 2 
            }}>
              {leftColumnContent}
            </Box>
          </Drawer>
          {/* Mobile main content */}
          <Box sx={{
            height: '100vh',
            overflow: 'auto',
            p: { xs: 1, sm: 2 } // Responsive padding
          }}>
            {/* Menu Button */}
            <Button
              variant="outlined"
              startIcon={<MenuIcon />}
              onClick={() => setDrawerOpen((open) => !open)}
              sx={{
                mb: 2,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: { xs: '0.875rem', sm: '1rem' } // Responsive font size
              }}
            >
              Menú
            </Button>
            {/* Custom Slider */}
            <Box 
              sx={{
                position: 'relative',
                width: '100%',
                height: { xs: '50px', sm: '60px' }, // Responsive height
                bgcolor: 'background.paper',
                borderRadius: { xs: 5, sm: 7 }, // Responsive border radius
                mb: { xs: 2, sm: 3 }, // Responsive margin
                overflow: 'hidden',
                cursor: 'pointer',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                display: 'flex'
              }}
              onClick={handleCategoryToggle}
            >
              {/* Amateur Section */}
              <Box
                sx={{
                  width: '50%',
                  height: '100%',
                  bgcolor: 'primary.main',
                  opacity: isAmateur ? 1 : 0.3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'opacity 0.3s ease-in-out'
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontWeight: isAmateur ? 'bold' : 'normal',
                    fontSize: { xs: '1rem', sm: '1.2rem' }, // Responsive font size
                    transition: 'font-weight 0.3s ease-in-out'
                  }}
                >
                  Amateur
                </Typography>
              </Box>
              {/* Infantiles Section */}
              <Box
                sx={{
                  width: '50%',
                  height: '100%',
                  bgcolor: 'primary.main',
                  opacity: !isAmateur ? 1 : 0.3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'opacity 0.3s ease-in-out'
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontWeight: !isAmateur ? 'bold' : 'normal',
                    fontSize: { xs: '0.9rem', sm: '1.2rem' }, // Responsive font size
                    transition: 'font-weight 0.3s ease-in-out'
                  }}
                >
                  Infantiles Juveniles
                </Typography>
              </Box>
            </Box>
            
            {/* Alert for users without profile when Infantiles is selected */}
            {!isAmateur && !hasProfile && (
              <Alert 
                severity="warning" 
                sx={{ 
                  mb: { xs: 2, sm: 3 }, // Responsive margin
                  cursor: 'pointer',
                  fontSize: { xs: '0.875rem', sm: '1rem' }, // Responsive font size
                  '&:hover': {
                    backgroundColor: 'warning.light',
                  }
                }}
                onClick={() => setIsEditModalOpen(true)}
              >
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  Registrar como padre
                </Typography>
                <Typography variant="body2">
                  Necesitas registrar tu perfil como padre para poder registrar a tus hijos.
                </Typography>
              </Alert>
            )}
            
            {visitedInfantiles && (
              <Box sx={{ display: isAmateur ? 'none' : 'contents' }}>
                <Infantiles user={user} clubes={clubes} giras={giras} registeredChildren={registeredChildren} onUpdate={fetchChildren} />
              </Box>
            )}
            {visitedAmateur && (
              <Box sx={{ display: isAmateur ? 'contents' : 'none' }}>
                <Amateur user={user} amateurData={amateurData} onUpdate={fetchAmateurData} clubes={clubes} />
              </Box>
            )}
          </Box>
        </>
      ) : (
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: isTablet ? '1fr 2fr' : '1fr 3fr', // Responsive grid columns
          gap: { xs: 2, sm: 3 }, // Responsive gap
          height: 'calc(100vh - 120px)',
          width: '100%'
        }}>
          {/* Left column - 1/4 width */}
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 2, sm: 3 }, // Responsive gap
            height: '100%'
          }}>
            {leftColumnContent}
          </Box>
          {/* Right column - 3/4 width */}
          <Box sx={{
            p: { xs: 2, sm: 3 }, // Responsive padding
            height: '100%',
            overflow: 'auto'
          }}>
            {/* Custom Slider */}
            <Box 
              sx={{
                position: 'relative',
                width: '100%',
                height: { xs: '50px', sm: '60px' }, // Responsive height
                bgcolor: 'background.paper',
                borderRadius: { xs: 5, sm: 7 }, // Responsive border radius
                mb: { xs: 2, sm: 3 }, // Responsive margin
                overflow: 'hidden',
                cursor: 'pointer',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                display: 'flex'
              }}
              onClick={handleCategoryToggle}
            >
              {/* Amateur Section */}
              <Box
                sx={{
                  width: '50%',
                  height: '100%',
                  bgcolor: 'primary.main',
                  opacity: isAmateur ? 1 : 0.3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'opacity 0.3s ease-in-out'
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontWeight: isAmateur ? 'bold' : 'normal',
                    fontSize: { xs: '1rem', sm: '1.2rem' }, // Responsive font size
                    transition: 'font-weight 0.3s ease-in-out'
                  }}
                >
                  Amateur
                </Typography>
              </Box>
              {/* Infantiles Section */}
              <Box
                sx={{
                  width: '50%',
                  height: '100%',
                  bgcolor: 'primary.main',
                  opacity: !isAmateur ? 1 : 0.3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'opacity 0.3s ease-in-out'
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontWeight: !isAmateur ? 'bold' : 'normal',
                    fontSize: { xs: '0.9rem', sm: '1.2rem' }, // Responsive font size
                    transition: 'font-weight 0.3s ease-in-out'
                  }}
                >
                  Infantiles Juveniles
                </Typography>
              </Box>
            </Box>
            
            {/* Alert for users without profile when Infantiles is selected */}
            {!isAmateur && !hasProfile && (
              <Alert 
                severity="warning" 
                sx={{ 
                  mb: { xs: 2, sm: 3 }, // Responsive margin
                  borderRadius: { xs: 5, sm: 7 }, // Responsive border radius
                  cursor: 'pointer',
                  fontSize: { xs: '0.875rem', sm: '1rem' }, // Responsive font size
                  '&:hover': {
                    backgroundColor: 'warning.light',
                  }
                }}
                onClick={() => setIsEditModalOpen(true)}
              >
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  Registrar como padre
                </Typography>
                <Typography variant="body2">
                  Necesitas registrar tu perfil como padre para poder registrar a tus hijos.
                </Typography>
              </Alert>
            )}

            {visitedInfantiles && (
              <Box sx={{ display: isAmateur ? 'none' : 'contents' }}>
                <Infantiles user={user} clubes={clubes} giras={giras} registeredChildren={registeredChildren} onUpdate={fetchChildren} />
              </Box>
            )}
            {visitedAmateur && (
              <Box sx={{ display: isAmateur ? 'contents' : 'none' }}>
                <Amateur user={user} amateurData={amateurData} onUpdate={fetchAmateurData} clubes={clubes} />
              </Box>
            )}
          </Box>
        </Box>
      )}
      <ProfileEditModal 
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        initialData={userData}
        onUpdate={fetchUserData}
        isCreateMode={!hasProfile}
      />

    </Box>
  );
};

export default Home;